"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Counter = function (_a) {
    var count = _a.count, color = _a.color, backgroundColor = _a.backgroundColor;
    return (React.createElement(StyledDiv, { "data-testid": "accordion-counter", color: color, backgroundColor: backgroundColor }, count));
};
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.8rem;\n  width: 1.8rem;\n  font-size: 1.2rem;\n  font-family: ", ";\n"], ["\n  border-radius: 50%;\n  background-color: ",
    ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.8rem;\n  width: 1.8rem;\n  font-size: 1.2rem;\n  font-family: ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.Teal[300];
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color !== null && color !== void 0 ? color : theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMonoMedium;
});
var templateObject_1;
